/* @flow */

exports.styled = require('./styled');
